module.exports = __webpack_public_path__ + "static/media/x-icon.46372d02.svg";